(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-map"] = factory();
	else
		root["vue-map"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _map = __webpack_require__(1);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _hint = __webpack_require__(3);
	
	var _hint2 = _interopRequireDefault(_hint);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Vue.component('vue-map', _map2.default);
	Vue.component('vue-map-hint', _hint2.default);
	
	// ------------------------------
	
	
	// Trigger / translator events for groups
	Raphael.el.trigger = function (name, params) {
	  this.events && this.events.forEach(function (event) {
	    event.name === name && event.f.call(this, params);
	  }, this);
	};
	
	// Trigger / translator of events for elements
	Raphael.st.trigger = function (event, params) {
	  this.forEach(function (elem) {
	    elem.trigger(event, params);
	  });
	};

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lang = __webpack_require__(2);
	
	exports.default = {
	  /**
	   * @see http://vuejs.org/api/options.html#template
	   */
	  template: '<div style="width: 100%; height: 100%"></div><slot></slot>',
	  /**
	   * @see http://vuejs.org/api/options.html#replace
	   */
	  replace: false,
	  /**
	   * @see http://vuejs.org/guide/components.html#Prop_Specification
	   */
	  props: {
	    size: {
	      type: Object,
	      default: {
	        width: '100%',
	        height: '100%'
	      }
	    },
	    elements: {
	      type: Array,
	      required: true
	    },
	    onMouseover: {
	      type: Function,
	      default: _lang.identity
	    },
	    onMouseout: {
	      type: Function,
	      default: _lang.identity
	    },
	    onClick: {
	      type: Function,
	      default: _lang.identity
	    }
	  },
	  /**
	   * @see http://v1.vuejs.org/api/#watch
	   */
	  watch: {
	    size: {
	      /**
	       * @param {Number} size.width
	       * @param {Number} size.height
	       */
	      handler: function handler(size) {
	        this.setSize(size);
	      },
	
	      deep: true
	    },
	    elements: {
	      /**
	       * @param {Array<Object>} array
	       */
	      handler: function handler(array) {
	        this.render(array);
	      },
	
	      deep: true
	    }
	  },
	  /**
	   * @see http://vuejs.org/api/options.html#methods
	   */
	  methods: {
	    /**
	     * @param {Object} config
	     * @param {Number} index
	     * @private
	     */
	    __onMouseOver: function __onMouseOver(config, index) {
	      var hint = this.pseudoHintElements[index];
	      if (hint && hint.transition.base) {
	        hint.removeClass(hint.transition.mouseOut);
	        hint.addClass(hint.transition.transition);
	        hint.addClass(hint.transition.mouseOver);
	      }
	      this.onMouseover(config);
	    },
	
	    /**
	     * @param {Object} config
	     * @param {Number} index
	     * @private
	     */
	    __onMouseOut: function __onMouseOut(config, index) {
	      var hint = this.pseudoHintElements[index];
	      if (hint && hint.transition.base) {
	        hint.removeClass(hint.transition.mouseOver);
	        hint.addClass(hint.transition.transition);
	        hint.addClass(hint.transition.mouseOut);
	      }
	      this.onMouseout(config);
	    },
	
	    /**
	     * @param {Array<Object>} arrayOfConfigs
	     * @returns {Object|null}
	     * @private
	     */
	    __extractBackground: function __extractBackground(arrayOfConfigs) {
	      var bg = arrayOfConfigs.filter(function (cfg) {
	        return cfg.type === 'image';
	      });
	      return bg[0] || null;
	    },
	
	    /**
	     * @param {Array<Object>} arrayOfConfigs
	     * @returns {Array<Object>}
	     * @private
	     */
	    __extractLayers: function __extractLayers(arrayOfConfigs) {
	      return arrayOfConfigs.filter(function (cfg) {
	        return cfg.type !== 'image';
	      });
	    },
	
	    /**
	     * @param {Raphael.Paper.Element} groupSvgElement
	     * @param {Object} animation.params
	     * @param {Number} animation.ms
	     * @param {String} animation.easing
	     * @private
	     */
	    __onAnimateSvgElement: function __onAnimateSvgElement(groupSvgElement, _ref) {
	      var params = _ref.params,
	          ms = _ref.ms,
	          easing = _ref.easing;
	
	      groupSvgElement.animate(params, ms, easing);
	    },
	
	    /**
	     * @see http://raphaeljs.com/reference.html#Paper.add
	     * @param {Array<Object>} array
	     */
	    render: function render(array) {
	      this.paper.clear();
	      this.frontSvgElements.length = 0;
	      this.pseudoHintElements.length = 0;
	
	      var background = this.__extractBackground(array);
	      var layers = this.__extractLayers(array);
	
	      if (background) {
	        var width = background.width,
	            height = background.height;
	
	        this.paper.setViewBox(0, 0, width, height);
	        this.paper.add([background]);
	        // Setting preserveAspectRatio to 'none' lets you stretch the SVG
	        // @see http://bertanguven.com/raphael-js-setsize-function
	        this.paper.canvas.setAttribute('preserveAspectRatio', 'xMidYMid slice');
	      }
	
	      for (var index = 0; index < layers.length; index++) {
	        var config = layers[index];
	        var groupSvgElement = this.paper.add([config]); // svg element
	
	        var events = config.events;
	        // Attach events handlers
	
	        if (events) {
	          for (var key in events) {
	            var animationObject = events[key];
	            var fn = this.__onAnimateSvgElement.bind(this, groupSvgElement, animationObject);
	            groupSvgElement[key](fn);
	          }
	        }
	
	        groupSvgElement.mouseover(this.__onMouseOver.bind(this, config, index));
	        groupSvgElement.mouseout(this.__onMouseOut.bind(this, config, index));
	        groupSvgElement.click(this.onClick.bind(this, config));
	        this.frontSvgElements.push(groupSvgElement);
	      }
	    },
	
	    /**
	     * @see http://raphaeljs.com/reference.html#Paper.setSize
	     * @param {Number} size.width
	     * @param {Number} size.height
	     */
	    setSize: function setSize(_ref2) {
	      var width = _ref2.width,
	          height = _ref2.height;
	
	      this.paper.setSize(width, height);
	    }
	  },
	  /**
	   * @see http://vuejs.org/api/options.html#compiled
	   */
	  compiled: function compiled() {
	    this.paper = new Raphael(this.$el.querySelector('div'));
	    this.frontSvgElements = [];
	    this.pseudoHintElements = [];
	  },
	
	  /**
	   * @see http://vuejs.org/api/options.html#attached
	   */
	  attached: function attached() {
	    this.setSize(this.size);
	    this.render(this.elements);
	  },
	
	  /**
	   * @see http://vuejs.org/api/options.html#destroyed
	   */
	  destroyed: function destroyed() {
	    this.paper.remove();
	    this.frontSvgElements.length = 0;
	    this.pseudoHintElements.length = 0;
	  }
	};

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * @param {*} any
	 * @returns {*}
	 */
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.identity = identity;
	exports.addClass = addClass;
	exports.removeClass = removeClass;
	exports.getOffset = getOffset;
	exports.getPosition = getPosition;
	exports.getSize = getSize;
	function identity(any) {
	  return any;
	}
	/**
	 * @param {HTMLElement} element
	 * @param {String} className
	 */
	function addClass(element, className) {
	  if (!className) return;
	  if (element.classList) {
	    element.classList.add(className);
	  } else {
	    var list = element.className.split('\s+');
	    list = list.filter(function (clsName) {
	      return clsName !== className;
	    });
	    list.push(className);
	    element.className = list.join(' ');
	  }
	}
	/**
	 * @param {HTMLElement} element
	 * @param {String} className
	 */
	function removeClass(element, className) {
	  if (!className) return;
	  if (element.classList) {
	    element.classList.remove(className);
	  } else {
	    var list = element.className.split('\s+');
	    list = list.filter(function (clsName) {
	      return clsName !== className;
	    });
	    element.className = list.join(' ');
	  }
	}
	/**
	 * @see http://learn.javascript.ru/coordinates-document#getCoords 
	 * @param {HTMLElement} element
	 * @returns {Object}
	 */
	function getOffset(element) {
	  var box = element.getBoundingClientRect();
	  return {
	    top: box.top + window.pageYOffset,
	    left: box.left + window.pageXOffset,
	    bottom: box.bottom + window.pageYOffset,
	    right: box.right + window.pageXOffset
	  };
	}
	/**
	 * @param {HTMLElement} element
	 * @returns {Object}
	 */
	function getPosition(element) {
	  var parentElement = element.parentNode;
	  var offset = getOffset(element);
	  var parentOffset = getOffset(parentElement);
	  var width = offset.right - offset.left;
	  var height = offset.bottom - offset.top;
	  var top = offset.top - parentOffset.top;
	  var left = offset.left - parentOffset.left;
	  return {
	    top: top,
	    left: left,
	    bottom: top + height,
	    right: left + width
	  };
	}
	/**
	 * @param {HTMLElement} element
	 * @returns {Object}
	 */
	function getSize(element) {
	  var _getOffset = getOffset(element),
	      top = _getOffset.top,
	      left = _getOffset.left,
	      bottom = _getOffset.bottom,
	      right = _getOffset.right;
	
	  var width = right - left;
	  var height = bottom - top;
	  return {
	    width: width,
	    height: height
	  };
	}

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PseudoHintElement = __webpack_require__(4);
	
	var _PseudoHintElement2 = _interopRequireDefault(_PseudoHintElement);
	
	var _lang = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  /**
	   * @see http://vuejs.org/api/options.html#replace
	   */
	  replace: false,
	  /**
	   * 
	   */
	  props: {
	    transition: {
	      type: String,
	      default: ''
	    }
	  },
	  /**
	   * @see http://vuejs.org/api/options.html#methods
	   */
	  methods: {
	    /**
	     *
	     */
	    render: function render() {
	      var _$parent = this.$parent,
	          frontSvgElements = _$parent.frontSvgElements,
	          pseudoHintElements = _$parent.pseudoHintElements,
	          paper = _$parent.paper;
	      var $index = this._scope.$index;
	
	      var groupSvgElement = frontSvgElements[$index];
	
	      if (!groupSvgElement) return;
	
	      var svgElement = groupSvgElement[0][0];
	
	      var _getPosition = (0, _lang.getPosition)(svgElement),
	          top = _getPosition.top,
	          left = _getPosition.left,
	          bottom = _getPosition.bottom,
	          right = _getPosition.right;
	
	      var width = right - left;
	      var height = bottom - top;
	
	      left += width / 2;
	      top += height / 2;
	
	      var element = this.$el;
	
	      left -= element.offsetWidth / 2;
	      top -= element.offsetHeight / 2;
	
	      var _getSize = (0, _lang.getSize)(paper.canvas),
	          paperWidth = _getSize.width,
	          paperHeight = _getSize.height;
	
	      var leftInPercents = 100 * left / paperWidth;
	      var topInPercents = 100 * top / paperHeight;
	
	      var style = element.style;
	
	      style.left = leftInPercents + '%';
	      style.top = topInPercents + '%';
	
	      element.onmouseenter = function () {
	        return groupSvgElement.trigger('mouseover');
	      };
	      element.onmouseleave = function () {
	        return groupSvgElement.trigger('mouseout');
	      };
	      element.onclick = function () {
	        return groupSvgElement.trigger('click');
	      };
	
	      var transition = this.transition;
	
	      var pseudoHintElement = new _PseudoHintElement2.default(element, transition);
	      pseudoHintElements.push(pseudoHintElement);
	    }
	  },
	  /**
	   * @see http://vuejs.org/api/options.html#attached
	   */
	  attached: function attached() {
	    // Provide the right order of rendering, from top to down: map.render() --> hint.render()
	    // A fix for http://gitlab.element-studio.ru:8008/bower/vue-map/issues/1
	    Vue.nextTick(this.render);
	  }
	};

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HintTransition = __webpack_require__(5);
	
	var _HintTransition2 = _interopRequireDefault(_HintTransition);
	
	var _lang = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PseudoHintElement =
	/**
	 *
	 * @param {HTMLElement} el
	 * @param {String} transition
	 */
	function PseudoHintElement(el, transition) {
	  _classCallCheck(this, PseudoHintElement);
	
	  this.transition = new _HintTransition2.default(transition);
	  this.addClass = _lang.addClass.bind(this, el);
	  this.removeClass = _lang.removeClass.bind(this, el);
	};
	
	exports.default = PseudoHintElement;

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * @see https://vuejs.org/guide/transitions.html#CSS-Transitions
	 */
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HintTransition = function () {
	  /**
	   * @param {String} baseClass
	   */
	  function HintTransition(baseClass) {
	    _classCallCheck(this, HintTransition);
	
	    this.base = baseClass;
	  }
	
	  _createClass(HintTransition, [{
	    key: 'transition',
	    get: function get() {
	      return this.base + '-transition';
	    }
	  }, {
	    key: 'mouseOver',
	    get: function get() {
	      return this.base + '-mouseover';
	    }
	  }, {
	    key: 'mouseOut',
	    get: function get() {
	      return this.base + '-mouseout';
	    }
	  }]);
	
	  return HintTransition;
	}();
	
	exports.default = HintTransition;

/***/ }
/******/ ])
});
;


// WEBPACK FOOTER //
// vue-map.min.js